import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconPropiedadescom from '../build/icon-propiedadescom'

export const IconPropiedadescom: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconPropiedadescom} />
}

export default IconPropiedadescom
